<template>
  <div>
    <section class="segment selectCustomer" v-if="ready">
      <div class="d-flex align-items-center">
        <h4 class="text-green my-0 mr-3">選擇商品</h4>
        <a
          class="btn btn-default mx-2"
          style="line-height: 20px; height: 40px"
          @click="startSelectProduct()"
        >
          選擇主約或商品組合 </a
        >&emsp;
        <!-- <a
          class="testProductionList ml_12"
          @click.stop="testProductionListOpen = true"
          v-if="$store.getters.BuTest"
          >測試商品清單</a
        > -->
        <TestProductionList
          :open="testProductionListOpen"
          @close="testProductionListOpen = false"
        />
        <MainProductPopup
          :open="MainProductPopupOpen"
          :mainProductSelected="mainProductSelected"
          @close="MainProductPopupOpen = false"
          @importProduct="importProductHandler($event, false)"
        />
        <NotValidNoticePopup
          :open="notValidList.length > 0"
          :notValidList="notValidList"
          @close="notValidList = []"
        />
      </div>
      <template v-for="(mainProduct, index) in mainProductSelected">
        <!-- 傳統型主約輸入畫面 start -->
        <MainProductInputItemTD
          v-if="mainProduct.FEATURE_DATA.prod_type == '1'"
          :key="mainProduct.uniqueKey"
          :mainIndex="index"
          :productData.sync="mainProductSelected[index]"
          :uniqueKey="mainProduct.uniqueKey"
          :validPayPrdOption="validPayPrdOptionMap[mainProduct.uniqueKey] || []"
          @delete="deleteMainHandler(mainProduct)"
          :ref="mainProduct.uniqueKey"
        >
          <div class="d-flex align-items-center mt_10">
            <div
              class="btn btn-primary px_6 Py_5"
              v-if="mainProduct.FEATURE_DATA.rider_type_nm != ''"
              @click="openScPopup(mainProduct)"
            >
              選擇附約
            </div>
            <div
              class="text-red fz_13 ml_2"
              v-if="
                mainProduct.group_sc_list &&
                mainProduct.group_sc_list.length > 0
              "
            >
              本商品包含您收藏的主附約組合，請點擊「選擇附約」查看並選擇收藏附約
            </div>
          </div>
          <!-- 選擇附約popup -->
          <ScPopup
            :open="mainProduct.ScPopup"
            :mainProduct="mainProduct"
            :uniqueKey="mainProduct.uniqueKey"
            @close="
              mainProduct.ScPopup = false;
              $forceUpdate();
            "
          />
          <!-- 附約輸入畫面 -->
          <ScInputItem
            v-show="mainProduct.sc_prod_list.length"
            :scProductList.sync="mainProduct.sc_prod_list"
            :uniqueKey="mainProduct.uniqueKey"
            :mainProduct="mainProduct"
            :level.sync="mainProductSelected[index].level"
          />
        </MainProductInputItemTD>
        <!-- 傳統型主約輸入畫面 end -->

        <!-- 投資型主約輸入畫面 start -->
        <MainProductInputItemIV
          v-if="mainProduct.FEATURE_DATA.prod_type != '1'"
          :key="mainProduct.uniqueKey"
          :mainIndex="index"
          :productData.sync="mainProductSelected[index]"
          :uniqueKey="mainProduct.uniqueKey"
          @delete="deleteMainHandler(mainProduct)"
          :haveSC="mainProduct.FEATURE_DATA.rider_type_nm != ''"
          :ref="mainProduct.uniqueKey"
          ><div class="d-flex align-items-center mt_10">
            <div
              class="btn btn-primary px_6 Py_5"
              v-if="mainProduct.FEATURE_DATA.rider_type_nm != ''"
              @click="openScPopup(mainProduct)"
            >
              選擇附約
            </div>
            <div
              class="text-red fz_13 ml_2"
              v-if="
                mainProduct.group_sc_list &&
                mainProduct.group_sc_list.length > 0
              "
            >
              本商品包含您收藏的主附約組合，請點擊「選擇附約」查看並選擇收藏附約
            </div>
          </div>
          <!-- 選擇附約popup -->
          <ScPopup
            :open="mainProduct.ScPopup"
            :mainProduct="mainProduct"
            :uniqueKey="mainProduct.uniqueKey"
            @close="
              mainProduct.ScPopup = false;
              $forceUpdate();
            "
          />
          <!-- 附約輸入畫面 -->
          <ScInputItem
            v-show="mainProduct.sc_prod_list.length"
            :scProductList.sync="mainProduct.sc_prod_list"
            :uniqueKey="mainProduct.uniqueKey"
            :mainProduct="mainProduct"
          />
        </MainProductInputItemIV>
        <!-- 投資型主約輸入畫面 end -->
      </template>
    </section>
    <section v-else class="product__empty">查詢中...</section>
  </div>
</template>

<script>
import ScPopup from "./SC_Popup";
import ScInputItem from "./SC_InputItem";
import MainProductPopup from "./MC_Popup.vue";
import moment from "moment";
//傳統型主約輸入畫面
import MainProductInputItemTD from "./MC_InputItem_TD.vue";
//投資型主約輸入畫面
import MainProductInputItemIV from "./MC_InputItem_IV.vue";
import NotValidNoticePopup from "./NotValidNoticePopup.vue";
//測試商品清單
import TestProductionList from "./TestProductionList.vue";

import mf_Mixin from "@/desktop/views/mf/mixin";
export default {
  props: ["checkCustomerIsvalid", "closeScNotice"],
  mixins: [mf_Mixin],
  components: {
    MainProductPopup,
    NotValidNoticePopup,
    MainProductInputItemTD,
    MainProductInputItemIV,
    ScPopup,
    ScInputItem,
    TestProductionList,
  },
  data() {
    return {
      testProductionListOpen: false,
      MainProductPopupOpen: false,
      notValidList: [],
      ready: false,
      validPayPrdOptionMap: {}, // 各主約過濾後的繳費年期 
    };
  },
  computed: {
    mainProductSelected: {
      get() {
        return this.$store.getters.MfEditing.mc_prod_list || [];
      },
      set(val) {
        this.$emit("update:mainProductSelected", val);
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      //自動帶入編輯中商品
      this.importProductHandler(
        this.$store.getters.MfEditing.mc_prod_list,
        true
      );
    },
    //開始選擇商品，但須檢核選擇客戶是否合法
    async startSelectProduct() {
      const CustomerIsvalid = await this.checkCustomerIsvalid();
      CustomerIsvalid && (this.MainProductPopupOpen = true);
    },
    //主約：檢核匯入商品，由popup匯入的商品，以及編輯時API回傳的商品在此檢核
    async importProductHandler($event, isEdit) {
      if ($event.length > 0) {
        this.MainProductPopupOpen = false;
        ///這邊呼叫檢核API，將importProductList區分
        let insured = this.$store.getters.MfEditing.insured;
        let res = await this.$mfAPI.MFA0_1000__checkMC({
          mc_prod_list: $event.map((item) => {
            return {
              prod_id: item.prod_id,
            };
          }),
          insured_age: insured.insured_age,
          legal_age:
            insured.insured_birthday == ""
              ? insured.insured_age
              : moment().diff(moment(insured.insured_birthday), "years") + "",
          gender: insured.insured_gender,
        });
        const validList = [];
        const notValidList = [];
        const importProductList = $event;
        //重新加回附約商屬(0715改動，因應查詢建議書瘦身不帶附約商屬)
        let MfEditing = this.$store.getters.MfEditing;
        let queryProdInfoById_map = {};
        if (MfEditing.prod_idx != "" && MfEditing.sc_prod_id_list.length > 0) {
          //編輯模式，須把SC商屬加回來
          queryProdInfoById_map =
            await this.$mfAPI.MFB0_1100__queryProdInfoById({
              prod_id_list: MfEditing.sc_prod_id_list,
            });
        }

        let memberLevel = "";

        if (
          MfEditing.prod_idx == "" &&
          this.$store.getters.MfEditing.insured.insured_age >= 18 &&
          this.$store.getters.MfEditing.insured.insured_id != "" &&
          !this.$store.getters.MfEditing.insured.insured_id.startsWith("~")
        ) {
          try {
            const { level } = await this.$mfAPI.MFA0_1000__getMemberExperience({
              memberId: this.$store.getters.MfEditing.insured.insured_id,
            });
            const numericLevel = level === "" ? "" : Number(level);
            if (Number.isFinite(numericLevel)) {
              memberLevel = numericLevel;
            }
          } catch (error) {
            console.error(error);
          }
        }

        for (let i = 0; i < importProductList.length; i++) {
          let mc = importProductList[i];
          if (res.mc_prod_map[mc.prod_id]) {
            mc.risk_ind_nm = res.mc_prod_map[mc.prod_id].risk_ind_nm; //產品風險屬性
            mc.FEATURE_DATA = res.mc_prod_map[mc.prod_id];
            mc.curr = res.mc_prod_map[mc.prod_id].curr;
            mc.prod_type = res.mc_prod_map[mc.prod_id].prod_type;
            mc.sc_prod_list = mc.sc_prod_list || [];
            if (MfEditing.prod_idx != "") {
              mc.sc_prod_list = mc.sc_prod_list.map((sc) => {
                let prod_pay_prd = sc.prod_pay_prd || null;
                if (!prod_pay_prd && queryProdInfoById_map[sc.prod_id]) {
                  prod_pay_prd =
                    queryProdInfoById_map[sc.prod_id].pay_prd || null;
                }
                let newScData = {
                  // $短年期
                  ...(queryProdInfoById_map[sc.prod_id] || {}),
                  ...sc,
                  prod_pay_prd,
                };
                if (!newScData.prod_pay_prd) {
                  newScData.pay_prd = null;
                }
                return newScData;
              });
            }

            //如果是投資型，先檢核年齡(0830新增機制)
            if (mc.prod_type != "1" && !isEdit) {
              let errorMessage = this.checkIVAge(mc.FEATURE_DATA);
              if (errorMessage != "") {
                return this.$mfNotice(errorMessage, () => {
                  this.MainProductPopupOpen = true;
                });
              }
            }
            mc.riskObj === undefined
              ? (mc.riskObj = this.$store.getters.kycRiskObjText)
              : (mc.riskObj = mc.riskObj || {});

            validList.push(mc);
          } else {
            mc.prod_type = res.mc_prod_map[mc.prod_id].prod_type;
            notValidList.push({ index: i + 1, prod: mc });
          }
        }

        if (importProductList[0].prod_type == "5") {
          if (!importProductList[0].fund) {
            importProductList[0].fund = {};
            importProductList[0].fund["fund"] = [];
          } else {
            if (importProductList[0].fund.fund) {
              //固定指數帳戶在前面
              importProductList[0].fund.fund.sort((a, b) => {
                let nameA = a.fund_id.toUpperCase();
                let nameB = b.fund_id.toUpperCase();
                if (nameB < nameA) {
                  return -1;
                }
                if (nameB > nameA) {
                  return 1;
                }
                return 0;
              });
            }
          }
        }

        if (importProductList[0].fund) {
          let { fund_map } = await this.$mfAPI.MFB1_1151__queryFundInfoMap({
            prod_id: importProductList[0].prod_id,
          });

          if (
            importProductList[0].fund["fund"] &&
            Array.isArray(importProductList[0].fund["fund"]) &&
            importProductList[0].fund["fund"].length === 0
          ) {
            importProductList[0].fund["fund"] = Object.values(fund_map).map(
              (item) => {
                return {
                  ...item,
                  dvd_kind: "",
                };
              }
            );
          }

          for (let key in importProductList[0].fund) {
            importProductList[0].fund[key] = importProductList[0].fund[key].map(
              (item) => {
                const fundData = fund_map[item.fund_id] || {};
                const { dvd_kind, ...rest } = fundData;
                return {
                  ...item,
                  ...rest,
                  ...(dvd_kind !== undefined ? { dvd_kind_opt: dvd_kind } : {}),
                };
              }
            );
          }
        }
        let index = 0;
        //開始判斷是否還能夠承保3/7新增機制
        for (let i = 0; i < validList.length; i++) {
          index++;
          let mc = validList[i];
          //4/19 投資型先排除，之後視情況加回
          // if (mc.FEATURE_DATA.prod_type == "2") continue;
          let error = this.getProdvalid(
            mc.FEATURE_DATA,
            this.$store.getters.MfEditing.insured.insured_age,
            mc.pay_prd,
            mc.pol_period,
            "主約",
            this.$store.getters.MfEditing.insured.insured_birthday,
            mc.deferred_prod,
            this.$store.getters.MfEditing.insured.insured_gender
          );
          if (error != "") {
            notValidList.push({
              index: index,
              prod: {
                prod_id: mc.prod_id,
                prod_name: mc.prod_name,
                error: error,
                prod_type: mc.FEATURE_DATA.prod_type,
              },
            });
            validList.splice(i, 1);
            i--;
            continue;
          }
          for (let j = 0; j < mc.sc_prod_list.length; j++) {
            let sc = mc.sc_prod_list[j];
            if (sc.is_checked != "1") continue;
            let error = this.getProdvalid(
              sc,
              sc.insured_age,
              sc.pay_prd,
              sc.pol_period,
              "附約",
              sc.insured_birthday,
              "",
              this.$store.getters.MfEditing.insured.insured_gender
            );
            if (error != "") {
              notValidList.push({
                index: index,
                prod: {
                  prod_id: sc.prod_id,
                  prod_name: sc.prod_name,
                  error: error,
                },
              });
              mc.sc_prod_list.splice(j, 1);
              j--;
              continue;
            }
          }
          if (mc.group_sc_list && mc.group_sc_list.length > 0) {
            //我的收藏組合選擇的附約，須把SC商屬加回來
            let groupSClist = [];
            groupSClist = await this.$mfAPI.MFB0_1100__queryProdInfoById({
              prod_id_list: mc.group_sc_list.map((item) => item.prod_id),
            });
            for (let j = 0; j < mc.group_sc_list.length; j++) {
              let groupSC = groupSClist[mc.group_sc_list[j].prod_id];
              const groupScList = mc.group_sc_list.map((item) => ({
                ...item,
                ...groupSC,
              }));
              let sc = groupScList[j];
              let error = this.getProdvalid(
                sc,
                this.$store.getters.MfEditing.insured.insured_age,
                "",
                "",
                "附約",
                this.$store.getters.MfEditing.insured.insured_birthday,
                "",
                this.$store.getters.MfEditing.insured.insured_gender
              );
              if (error != "") {
                notValidList.push({
                  index: index,
                  prod: {
                    prod_id: sc.prod_id,
                    prod_name: sc.prod_name,
                    error: error,
                  },
                });
                mc.group_sc_list.splice(j, 1);
                j--;
                continue;
              }
            }
          }
        }
        this.notValidList = notValidList;
        // 重新建立各商品可用的繳費年期 (避免重新匯入商品，留下前一批商品資料)
        this.validPayPrdOptionMap = {};
        this.mainProductSelected = validList.map((item, index) => {
          item.mc_idx = item.mc_idx || ""; //主約建議書ID，新增時帶空
          item.pay_prd = item.pay_prd || ""; //繳費年期
          item.pay_freq = item.pay_freq || ""; //繳別
          item.amt = item.amt || ""; //保額
          item.pol_period = item.pol_period || ""; //保險期間
          item.deferred_prod = item.deferred_prod || ""; //遞延期間
          item.pay_dis = item.pay_dis || ""; //繳費方式折減
          item.group_dis = item.group_dis || "0"; //集彙折減
          item.premium = item.premium || ""; //預估投入保費
          item.pol_premium = item.pol_premium || ""; //每期保費
          item.first_premium = item.first_premium || ""; //每期保費
          item.job_cat = item.job_cat || ""; //職業別
          item.add_method = item.add_method || ""; //增值回饋分享金
          item.sc_prod_list = item.sc_prod_list || []; //附約
          item.amt_unit = item.FEATURE_DATA.amt_unit; //單位
          item.mc_order = index + 1;
          item.uniqueKey = this.$uniqueKey();
          item.risk_ind = item.risk_ind || "";
          item.risk_ind_nm = item.risk_ind_nm || "";
          item.riskObj = item.riskObj || {};
          item.is_untm_prem = item.FEATURE_DATA.is_untm_prem || "";
          item.div_type = item.div_type || "";
          item.cwp_level = item.cwp_level || "0";
          item.is_spillover4 = item.is_spillover4 || "0";
          item.level = item.level || memberLevel;
          // 傳統型商品才需要過濾繳費年期
          if (item.FEATURE_DATA.prod_type == "1") {
            this.$set(
              this.validPayPrdOptionMap,
              item.uniqueKey,
              this.getValidPayPrdOption(item)
            );
          }
          return item;
        });
        this.$nextTick(() => {
          this.ready = true;
          this.registerHanlink(); //難字更新
        });
      } else {
        this.ready = true;
        this.registerHanlink(); //難字更新
      }
    },
    //主約:刪除
    deleteMainHandler(targetObject) {
      this.mainProductSelected = this.mainProductSelected.filter((item) => {
        return item != targetObject;
      });
    },
    //確認投資型商品年齡檢核(0830新增)
    checkIVAge(FEATURE_DATA) {
      //判斷是否在商品的年齡上下限
      let errorMessage = "";
      //要保人年齡上下限檢核
      let insurer_age = parseInt(
        this.$store.getters.MfEditing.insurer.insured_age
      );
      let insurer_actage = this.$store.getters.MfEditing.insurer
        .insured_birthday
        ? parseInt(
            moment().diff(
              moment(this.$store.getters.MfEditing.insurer.insured_birthday),
              "years"
            )
          )
        : insurer_age;
      let isActAge_floor = FEATURE_DATA.assured_age_kind == "2";
      let insurer_age_floor = isActAge_floor ? insurer_actage : insurer_age;

      if (
        FEATURE_DATA.assured_age_ceil != undefined &&
        FEATURE_DATA.assured_age_ceil_kind != "0"
      ) {
        let isActAge_ceil = FEATURE_DATA.assured_age_ceil_kind == "2";
        let insurer_age_ceil = isActAge_ceil ? insurer_actage : insurer_age; //判斷要保人年齡上限使用保險年齡或實際年齡(assured_age_ceil_kind = 1 保險年齡 、 =2 實際年齡)
        if (
          insurer_age_floor < FEATURE_DATA.assured_age_floor ||
          insurer_age_ceil > FEATURE_DATA.assured_age_ceil
        ) {
          errorMessage += `${FEATURE_DATA.prod_name}(${
            FEATURE_DATA.prod_id
          })<br><br><span class="text-red">要保人年齡需年滿${
            FEATURE_DATA.assured_age_floor
          }${isActAge_floor ? "足" : ""}歲至${FEATURE_DATA.assured_age_ceil}${
            isActAge_ceil ? "足" : ""
          }歲。</span>`;
        }
      } else {
        if (insurer_age_floor < FEATURE_DATA.assured_age_floor) {
          errorMessage += `${FEATURE_DATA.prod_name}(${
            FEATURE_DATA.prod_id
          })<br><br><span class="text-red">要保人年齡需年滿${
            FEATURE_DATA.assured_age_floor
          }${isActAge_floor ? "足" : ""}歲。</span>`;
        }
      }
      //被保人年齡上下限檢核
      //區分法定年齡與保險年齡邏輯(2022/3/18新增 )
      let insured_age = parseInt(
        this.$store.getters.MfEditing.insured.insured_age
      ); //被保人年齡(檢核下限用，預設值:保險年齡)
      let insured_actage = this.$store.getters.MfEditing.insured
        .insured_birthday
        ? parseInt(
            moment().diff(
              moment(this.$store.getters.MfEditing.insured.insured_birthday),
              "years"
            )
          )
        : insured_age;
      isActAge_floor = FEATURE_DATA.age_floor_kind == "2"; //2=使用法定年齡
      let insured_age_floor = isActAge_floor ? insured_actage : insured_age;
      let isActAge_ceil = FEATURE_DATA.age_ceil_kind == "2";
      let insured_age_ceil = isActAge_ceil ? insured_actage : insured_age;
      let age_ceil = parseInt(FEATURE_DATA.age_ceil);
      let age_floor = parseInt(FEATURE_DATA.age_floor);
      let prod_name_id = `${FEATURE_DATA.prod_name}(${FEATURE_DATA.prod_id})`;
      if (age_ceil < insured_age_ceil || age_floor > insured_age_floor) {
        if (errorMessage === "") {
          errorMessage += prod_name_id;
        }
        errorMessage += `<br><br>
        <span class="text-red">主約被保險人限${age_floor}${
          isActAge_floor ? "足" : ""
        }歲至${age_ceil}${isActAge_ceil ? "足" : ""}歲。</span>
        `;
      }
      //被保險人性別檢核
      let prod_sex = FEATURE_DATA.gender_ind;
      let insured_sex =
        this.$store.getters.MfEditing.insured.sex ||
        this.$store.getters.MfEditing.insured.insured_gender;
      if (prod_sex != 0 && insured_sex != prod_sex) {
        let sexStr = this.$paragrpno.gender_ind
          .filter((item) => item.paraval === prod_sex)
          .map((item) => item.paradetlno);
        if (errorMessage === "") {
          errorMessage += prod_name_id;
        }
        errorMessage += `<br><br><span class="text-red">主約被保險人限${sexStr}性。</span>`;
      }
      return errorMessage;
    },
    // checkOneMainProductInput(uniqueKey) {
    //   this.$refs[uniqueKey].validateAll();
    // },
    //開始選擇附約
    async openScPopup(mainProduct) {
      let check = true;
      //投資型暫定
      if (mainProduct.prod_type != "1") {
        //萬能變額僅檢核保額計畫
        check = await this.$refs[mainProduct.uniqueKey][0].validatePlan(true);
      } else {
        check = await this.$refs[mainProduct.uniqueKey][0].validateAll(true);
      }

      if (check) {
        if (
          this.$store.getters.MfEditing.prod_idx != "" &&
          !this.closeScNotice &&
          this.$store.getters.MfEditing.insured.insured_id != ""
        ) {
          this.$mfNotice(
            `<strong>選擇附約將以目前的CRM家戶成員資料為準!</strong>
          <br/><br/>
          選擇附約將以CRM最新的家戶資料帶入，若原選擇的附約被保人已不在同一家戶，系統將自動刪除。`,
            () => {
              mainProduct.ScPopup = true;
              this.$forceUpdate();
            },
            true
          );
        } else {
          mainProduct.ScPopup = true;
          this.$forceUpdate();
        }
      }
    },
    // 展開逗號及波浪區間選項
    getPeriodOptionList(periodString) {
      let optionList = [];
      if (!periodString) {
        return optionList;
      }

      periodString.split(",").forEach((item) => {
        if (item.indexOf("~") > 0) {
          let startIndex = parseInt(item.split("~")[0]);
          let endIndex = parseInt(item.split("~")[1]);

          for (let i = startIndex; i <= endIndex; i++) {
            optionList.push(i.toString());
          }
        } else {
          optionList.push(item);
        }
      });
      return optionList;
    },
    // renew_type 3、4 的處理需與 MC_InputItem_TD.vue > computed.option() 一致。
    // 取得商品完整繳費年期選項
    getPayPrdOptionList(FEATURE_DATA) {
      // 自動續保商品，繳費年期固定為 1
      if (
        FEATURE_DATA.renew_type == "3" ||
        FEATURE_DATA.renew_type == "4"
      ) {
        return ["1"];
      }

      return this.getPeriodOptionList(
        FEATURE_DATA.pay_prd
      );
    },
    // 取得該繳費年期實際可搭配的保險期間
    // pay_to_pol 商品必須使用「完整繳費年期清單」的 index，對應相同 index 的保險期間。此邏輯必須與 MC_InputItem_TD.vue > changePeriod() 保持一致。
    getCheckPolPeriodOption(
      productData,
      payPrd,
      payPrdOptionList,
      polPeriodOptionList
    ) {
      let FEATURE_DATA = productData.FEATURE_DATA;
      // 繳費年期與保險期間依 index 連動
      if (
        this.$special_array("pay_to_pol").includes(
          productData.prod_id
        )
      ) {
        let index = payPrdOptionList.indexOf(payPrd);
        let polPeriod = polPeriodOptionList[index];

        return polPeriod ? [polPeriod] : [""];
      }
      // 保險期間與繳費年期相同
      // 必須與 MC_InputItem_TD.vue > extraHandler() 的設定邏輯一致。
      if (FEATURE_DATA.same_pay_period !== "0") {
        return [payPrd];
      }
      // 有多個保險期間時，逐一搭配檢核
      if (polPeriodOptionList.length > 0) {
        return polPeriodOptionList;
      }
      // 沒有保險期間選項
      return [""];
    },
    // 依被保險人、保險期間及遞延期間過濾繳費年期
    getValidPayPrdOption(productData) {
      let FEATURE_DATA = productData.FEATURE_DATA;
      let insured = this.$store.getters.MfEditing.insured;
      // 完整繳費年期
      let payPrdOptionList = this.getPayPrdOptionList(FEATURE_DATA);
      // 完整保險期間
      let polPeriodOptionList = this.getPeriodOptionList(FEATURE_DATA.pol_period);
      // 完整遞延期間
      let deferredOptionList = this.getPeriodOptionList(FEATURE_DATA.deferred_prod);

      // 沒有遞延期間時也要執行一次檢核，所以放一個空字串作為檢核組合。
      if (deferredOptionList.length === 0) {
        deferredOptionList = [""];
      }

      return payPrdOptionList.filter((payPrd) => {
        let checkPolPeriodOptionList =
          this.getCheckPolPeriodOption(
            productData,
            payPrd,
            payPrdOptionList,
            polPeriodOptionList
          );

        // 只要存在一組合法的：繳費年期＋保險期間＋遞延期間，就保留該繳費年期。
        return checkPolPeriodOptionList.some(
          (polPeriod) => {
            return deferredOptionList.some(
              (deferredProd) => {
                return (
                  this.getProdvalid(
                    FEATURE_DATA,
                    insured.insured_age,
                    payPrd,
                    polPeriod,
                    "主約",
                    insured.insured_birthday,
                    deferredProd,
                    insured.insured_gender
                  ) == ""
                );
              }
            );
          }
        );
      });
    },
  },
  watch: {
    mainProductSelected: {
      handler(val) {
        this.$emit("update:mainProductSelected", val);
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
//測試商品清單
.testProductionList {
  font-size: 13px;
  color: #027a39;
  font-family: PMingLiU;
  text-decoration: underline;
  cursor: pointer;
  margin-top: auto;
  margin-bottom: 12px;
}
.product__empty {
  min-height: 55vh;
  margin-bottom: 5vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: #323a45;
}
</style>
